import _ from 'lodash'
import { flow, sumBy, get, map } from 'lodash/fp'
import MESSAGES from 'core/data-model/constants/bi-messages'
import VALUES from 'core/data-model/constants/values'
import { d } from 'core/service/lib/decimal'

export const summaryBenefits = (investmentBenefits, productCode) => {
  let sumGuarantee = 0
  let sumRates = []
  investmentBenefits.forEach((v) => {
    sumGuarantee += v.guaranteeValue
    v.rates.forEach((v, k) => {
      sumRates[k] = sumRates[k] ? sumRates[k] + v : v
    })
  })

  return {
    title:
      Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(productCode) ||
      Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(productCode) ||
      Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(productCode)
        ? MESSAGES.INVESTMENT_BENEFITS_GUARANTEE_TOTAL + ' (1) + (2)'
        : MESSAGES.INVESTMENT_BENEFITS_GUARANTEE_TOTAL,
    guaranteeValue: sumGuarantee,
    rates: sumRates,
  }
}

export const getGuaranteeBenefits = (investmentBenefitTableParams) => {
  const yearEndPolicyValues = get('yearEndPolicyValues')(investmentBenefitTableParams.policyValue)
  const dividendRates = get('dividendRates')(investmentBenefitTableParams)
  const cashDropSummary = flow(sumBy('cashDrop'))(yearEndPolicyValues)
  const guaranteeMaturity = get('cashDrop')(yearEndPolicyValues[yearEndPolicyValues.length - 1])
  const cashDropWithOutLast = cashDropSummary - guaranteeMaturity
  const productCode = get('productCode')(investmentBenefitTableParams)

  let results = [
    {
      title:
        Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(productCode) ||
        Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(productCode) ||
        Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(productCode)
          ? MESSAGES.INVESTMENT_BENEFITS_GUARANTEE_CASHDROP + ' รวม\n (กรณีรับเงินจ่ายคืนทุกปี)'
          : MESSAGES.INVESTMENT_BENEFITS_GUARANTEE_CASHDROP,
      guaranteeValue: cashDropWithOutLast,
      rates: generateFixDividend(dividendRates, cashDropWithOutLast),
    },
    {
      title: MESSAGES.INVESTMENT_BENEFITS_GUARANTEE_MATURITY,
      guaranteeValue: guaranteeMaturity,
      rates: generateFixDividend(dividendRates, guaranteeMaturity),
    },
  ]
  return [...results, summaryBenefits(results, productCode)]
}

export const getNonGuaranteeBenefits = (
  investmentBenefitTableParams
  // productCategory: string
) => {
  const subtotalCashDrop = get('subtotalCashDrop')(investmentBenefitTableParams.policyValue)
  const dividendRates = get('dividendRates')(investmentBenefitTableParams)
  const sumAssured = get('sumAssured')(investmentBenefitTableParams)
  const dividendBysumAssured = generateDividendBysumAssured(dividendRates, sumAssured)

  const productCode = get('productCode')(investmentBenefitTableParams)
  const subtotalNonGuaranteeDividend = get('subtotalNonGuaranteeDividend')(investmentBenefitTableParams.policyValue)

  return [
    {
      title:
        Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(productCode) ||
        Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(productCode) ||
        Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(productCode)
          ? MESSAGES.GLOBAL_INDEX_16_6_INVESTMENT_BENEFITS_NONGUARANTEE_MATURITY
          : MESSAGES.INVESTMENT_BENEFITS_NONGUARANTEE_MATURITY,
      guaranteeValue: 0,
      rates:
        Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(productCode) ||
        Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(productCode) ||
        Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(productCode)
          ? Object.values(subtotalNonGuaranteeDividend)
          : dividendBysumAssured,
    },
    {
      title:
        Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(productCode) ||
        Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(productCode) ||
        Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(productCode)
          ? MESSAGES.GLOBAL_INDEX_16_6_INVESTMENT_BENEFITS_NONGUARANTEE_TOTAL
          : MESSAGES.INVESTMENT_BENEFITS_NONGUARANTEE_TOTAL,
      guaranteeValue: subtotalCashDrop,
      rates:
        Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(productCode) ||
        Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(productCode) ||
        Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(productCode)
          ? flow(map((v) => v + subtotalCashDrop))(Object.values(subtotalNonGuaranteeDividend))
          : flow(map((v) => v + subtotalCashDrop))(dividendBysumAssured),
    },
  ]
}

export const getBenefitSummaryUniversalLink = (investmentBenefitTableParams) => {
  const yearEndPolicyValues = get('yearEndPolicyValues')(investmentBenefitTableParams.policyValue)
  const cashDropMaturity = get('cashDrop')(yearEndPolicyValues[yearEndPolicyValues.length - 1])
  const deathBenefitFirstYear = _.get(
    yearEndPolicyValues.find((value) => value.yearEndPolicy === 1),
    'deathBenefit',
    0
  )
  const cashDropTwoPercent = _.get(
    yearEndPolicyValues.find((value) => value.yearEndPolicy === 2),
    'cashDrop',
    0
  )
  const cashDropSixPercent = _.get(
    yearEndPolicyValues.find((value) => value.yearEndPolicy === 6),
    'cashDrop',
    0
  )

  return [
    {
      title: MESSAGES.GLOBAL_INDEX_16_6_DEATH_BENEFIT_MINIMUM_TITLE,
      value: deathBenefitFirstYear,
    },
    {
      title: MESSAGES.GLOBAL_INDEX_16_6_BENEFIT_CASH_DROP_TITLE,
      value: '',
    },
    {
      title: MESSAGES.GLOBAL_INDEX_16_6_BENEFIT_CASH_DROP_TWO_PERCENT,
      value: cashDropTwoPercent,
    },
    {
      title: MESSAGES.GLOBAL_INDEX_16_6_BENEFIT_CASH_DROP_SIX_PERCENT,
      value: cashDropSixPercent,
    },
    {
      title: MESSAGES.GLOBAL_INDEX_16_6_BENEFIT_CASH_DROP_MATURITY_TITLE,
      value: cashDropMaturity,
    },
    {
      title: MESSAGES.GLOBAL_INDEX_16_6_DIVIDEND_TITLE,
      value: MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[5].benefit,
    },
  ]
}

export const generateFixDividend = (rates, fixRate) => {
  return rates.map((v) => d(fixRate).toNumber())
}

export const generateDividendBysumAssured = (rates, sumAssured) => {
  return rates.map((v) =>
    d(sumAssured)
      .dividedBy(100)
      .times(v.rate)
      .toNumber()
  )
}

export const generateInvestmentBenefit = (investmentBenefitTableParams) => {
  const productCode = get('productCode')(investmentBenefitTableParams)
  const investmentBenefit = {
    guaranteeBenefits: getGuaranteeBenefits(investmentBenefitTableParams),
    nonGuaranteeBenefits: getNonGuaranteeBenefits(investmentBenefitTableParams),
  }

  if (
    Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(productCode) ||
    Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(productCode) ||
    Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(productCode)
  ) {
    const benefitSummaryUniversalLink = getBenefitSummaryUniversalLink(investmentBenefitTableParams)
    Object.assign(investmentBenefit, {
      benefitSummaryUniversalLink,
    })
  }
  return investmentBenefit
}
